<template>
  <div>
    <p>
      {{ recipient.email }} ({{ recipient.name }})
    </p>
    <p
      v-if="recipient.assistants && recipient.assistants.length > 0"
      class="mt-1 is-size-7 has-text-grey is-italic"
    >
      {{
        $t('resourceNotificationsCreateModal.recipientsChooser.assistants_label', {
          assistants: recipient.assistants.map(assistant => assistant.email).join(', ')
        })
      }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'ResourceNotificationsRecipientListItem',
  props: {
    recipient: {
      type: Object,
      required: true
    }
  }
}
</script>
